/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

/**
 * 背景動画
 *
 * @param playerId 動画を再生するエリアのID
 * @param videoId Youtubeの動画ID
 */
function initBackgroundVideo(playerId, videoId) {
    // YouTube Player APIの読み込み
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // プレイヤーを埋め込む場所(IDを指定)
    let ytPlayer;

    // プレイヤーの埋め込み
    function onYouTubeIframeAPIReady() {
        ytPlayer = new YT.Player(playerId, {
            videoId: videoId,
            playerVars: {
                'controls': 0, // プレイヤーコントロールの非表示
                'disablekb': 0, // キーボード無効化
                'modestbranding': 1, // YouTubeロゴの非表示
                'iv_load_policy': 3, // アノテーションの非表示
                'fs': 0, //全画面ボタン非表示,
                'cc_load_policy': 0, //字幕を無効化
                'playsinline': 1, // iosでインライン再生
                'rel': 0 // 自分のチャンネル以外の関連動画を非表示
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    // 動画の準備完了後の動作 ミュートで再生
    function onPlayerReady(e) {
        const $player = document.getElementById(playerId);
        $player.removeAttribute("referrerpolicy");

        ytPlayer.playVideo();
        ytPlayer.mute();
        ytPlayer.setPlaybackQuality('default'); // 画質(small・medium・large・hd720・hd1080・highres・default)
    }
    window.onPlayerReady = onPlayerReady;

    // 動画再生中と再生後の動作
    function onPlayerStateChange(e) {
        const ytStatus = e.target.getPlayerState();
        if (ytStatus === YT.PlayerState.PLAYING) {
            //再生中 無し
        }
        if (ytStatus === YT.PlayerState.ENDED) {
            //再生後 ミュートで再度再生
            ytPlayer.playVideo();
            ytPlayer.mute();
        }
    }
    window.onPlayerStateChange = onPlayerStateChange;

    function playMovieIfNeeded(time) {
        // 終了、一時停止中の場合は再生
        setTimeout(function () {
            const ytStatus = ytPlayer.getPlayerState();
            if (ytStatus === YT.PlayerState.ENDED || ytStatus === YT.PlayerState.PAUSED) {
                ytPlayer.playVideo();
                ytPlayer.mute();
            }
        }, time);
    }

    window.addEventListener("pageshow", function(){
        playMovieIfNeeded(1000);
    });

    window.addEventListener("focus", function(){
        playMovieIfNeeded(1500);
    });
}


(function() {
  // Add custom code below this line

    /**
     * 背景動画
     */
    $(".youtube-player").each(function (index, elem){
        const $elem = $(elem);

        let playerId = "";
        const sectionId = $elem.data("section-id");
        if(sectionId) {
            playerId = "player_" + sectionId;
        }

        let videoId = "";
        if(window.innerWidth < 769) {
            videoId = $elem.data("video-id");
        } else {
            videoId = $elem.data("video-pc-id");
        }

        if(playerId && videoId) {
            initBackgroundVideo(playerId, videoId);
        } else {
            console.log("#shopify-section-" + sectionId);
            $("#shopify-section-" + sectionId).hide();
        }
    });
})();